import { ThemeProvider } from "@hireroo/ui-theme/theme-v2";
import { ErrorBoundary, withErrorBoundary } from "@sentry/react";
import * as React from "react";

import MaintenanceContainer from "./routes/Maintenance/Container";

const Maintenance: React.FC = () => {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <MaintenanceContainer />
      </ThemeProvider>
    </ErrorBoundary>
  );
};

Maintenance.displayName = "Maintenance";

export default withErrorBoundary(Maintenance, {});
